var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_64338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_64338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3751 21L2.9751 19.6L13.2251 9.35C12.9251 8.65 12.8834 7.85833 13.1001 6.975C13.3168 6.09167 13.7918 5.3 14.5251 4.6C15.4084 3.71667 16.3918 3.2 17.4751 3.05C18.5584 2.9 19.4418 3.16667 20.1251 3.85C20.8084 4.53333 21.0751 5.41667 20.9251 6.5C20.7751 7.58333 20.2584 8.56667 19.3751 9.45C18.6751 10.1833 17.8834 10.6583 17.0001 10.875C16.1168 11.0917 15.3251 11.05 14.6251 10.75L13.3751 12L20.9751 19.6L19.5751 21L11.9751 13.45L4.3751 21ZM7.3251 12.45L4.3251 9.45C3.4251 8.55 2.9751 7.475 2.9751 6.225C2.9751 4.975 3.4251 3.9 4.3251 3L10.5251 9.25L7.3251 12.45Z",
    fill: "#707072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/Food.f0259e62.svg";
export { ForwardRef as ReactComponent };